(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-mobile-header"] && !Shopify.designMode) return;
  try {
    function compactCollectionDescription(root) {
    root.querySelectorAll('.folders-collection-mobile__full').forEach(content => {
      let tail = content.lastChild;
      while (tail) {
        if (tail.nodeType === 8 || (tail.nodeType === 3 && !tail.textContent.trim())) {
          tail = tail.previousSibling;
          continue;
        }
        if (tail.nodeType !== 1) break;
        const plainAttributes = Array.from(tail.attributes).every(attribute =>
          attribute.name === 'style' || (attribute.name === 'class' &&
            Array.from(tail.classList).every(name => name === 'folders-collection-mobile__empty-tail'))
        ) && Array.from(tail.style).every(property => property === 'text-align');
        const emptyBlock = ['P', 'DIV'].includes(tail.tagName) && plainAttributes &&
          Array.from(tail.childNodes).every(node =>
            (node.nodeType === 3 && !node.textContent.trim()) ||
            (node.nodeType === 1 && node.tagName === 'BR')
          );
        if (!emptyBlock) {
          tail.classList.add('folders-collection-mobile__content-end');
          break;
        }
        tail.classList.add('folders-collection-mobile__empty-tail');
        tail = tail.previousSibling;
      }
    });
  }
  compactCollectionDescription(document);
  document.addEventListener('shopify:section:load', event => compactCollectionDescription(event.target));
  } catch(e) { console.error(e); }
})();

})();
